export interface AheduConfig {
  env: 'test' | 'pre-prod' | 'prod',
  getHost (): string,
}

const Config = {
  env: 'pre-prod',
  getHost (): string {
    switch (this.env) {
      case 'test':
        return '//ahtest.changyan.cn'
      case 'pre-prod':
        return 'https://ahpro.ahedu.cn'
      case 'prod':
        return 'https://www.ahedu.cn'
    }
  },
} as AheduConfig

export default Config